import { onDomReady } from '../utils/dom';
import { DropdownMenu } from '../utils/dropdown-menu';

/**
 * @typedef MenuOptions
 * @property {string} selector
 * @property {string} navButton
 * @property {{ element: string, close: string }} [overlay]
 */

const MainMenu = {
    selector: '#header .main-nav',
    navButton: '#header .nav-button',
    // overlay: {
    //     element: '#nav-overlay',
    //     close: '#nav-close',
    // },
};

onDomReady(() => {
    new DropdownMenu(MainMenu);
});
